module.exports = __webpack_public_path__ + "img/like.57609717.svg";